import {ActionTree} from "vuex";
import {ContractProfileState, ContractProfile} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<ContractProfileState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/contract_profiles', {params: params})
        .then((response: AxiosResponse) => {
          const contractProfiles: ContractProfile[] = response.data;
          commit('setContractProfiles', contractProfiles);
          return contractProfiles;
        });
  },
  get({ rootGetters, commit }, params) {
    const id = params.id;
    delete params.id;
    return rootGetters['hcs/client'].get(`/contract_profiles/${id}`, { params: params })
        .then((response: AxiosResponse) => {
          return response.data as ContractProfile
        })
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/contract_profiles', params)
        .then((response: AxiosResponse) => {
          const contractProfile: ContractProfile = response.data;
          commit('addContractProfile', contractProfile);
          return contractProfile;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/contract_profiles/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const contractProfile: ContractProfile = response.data;
          commit('updateContractProfile', contractProfile);
          return contractProfile;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/contract_profiles/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteContractProfile', id);
          return id;
        });
  }
}

export default actions;
